module.exports = __webpack_public_path__ + "img/rec_2.b9a48b3c.png";